<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" max-width="290"  persistent style="border-radius:12px;">
      <v-card color="primary lighten-1" dark>
        <v-card-text class="text-center">
          {{titulo}}
          <br><br>
          <div style="text-align:center;">
            <v-progress-circular indeterminate color="white" class="mb-0"></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["titulo", "dialog"]
};
</script>
